<template>
  <div>
    <div class="load-container" v-if="loading">
      <Spinner size="80" :line-size="8"></Spinner>
    </div>

    <div class="container-fluid" style="z-index:9; position: relative">
      <div class="row" v-if="false">
        <nav class="navbar navbar-default">
          <div class="container">
            <div class="navbar-header">
              <button style="color: #9D9D9D;padding: 7px 10px 6px;" type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                data-target="#navbar-collapse-login" aria-expanded="false">
                <i class="fa fa-bars fa-2x"></i>
              </button>
              <a class="navbar-brand" href="#">
                <img alt="AR-Online" style="max-width: 160px; height:45px" src="@/assets/images/logo-aronline.png">
              </a>
            </div>
            <div class="collapse navbar-collapse" id="navbar-collapse-login">
              <ul class="nav navbar-nav navbar-right">
                <li>
                  <a href="http://www.ar-email.com.br">
                    <i class="fa fa-chevron-left" aria-hidden="true"></i> Voltar
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>

        <!-- E-mail -->
        <AppInfo v-if="!loading"
          :subject="subject"
          :remetente="remetente"
          :destinatario="destinatario"
          :content="content"
          :dataEnviada="dataEnviada"
          :horaEnviada="horaEnviada"
          :dataEntrega="dataEntrega"
          :horaEntrega="horaEntrega"
          :dataLeitura="dataLeitura"
          :horaLeitura="horaLeitura"
          :idImage="idImage"
          :dataLeituraUTC="dataLeituraUTC"
          :emailRawDecoded="emailRawDecoded"
          :detalhesEnvioEntrega="detalhesEnvioEntrega"
          :carimboEmailEntregue="carimboEmailEntregue"
          :detalhesLeitura="detalhesLeitura"
          provider="bry"
          :loading="loading"
          :error="error"
          :emailSent="emailSent"
          :smsSent="smsSent"
          :numeroCelular="numeroCelular"
          :mensagem="mensagem"
          :detalhesEnvioEntregaSMS="detalhesEnvioEntregaSMS"
          :detalhesLeituraSMS="detalhesLeituraSMS"
          :dataEnvioSMS="dataEnvioSMS"
          :dataLeituraSMS="dataLeituraSMS"
          :statusSMS="statusSMS"
        />

        <!-- Emails Não Enviado ou com Erro -->
        <!-- <AppInfoEmailNotSend v-if="emailNotSent"
          :subject="subject"
          :content="content"
          :loading="loading"
        /> -->

        <!-- <AppInfoEmailNotSend v-if="emailNotSentAndHasSMS || emailNotSent"
          :subject="subject"
          :content="content"
          :loading="loading"
          :hasSMS="hasSMS"
        /> -->
    </div>

    <AppFooter />
  </div>
</template>
<script>
import Spinner from 'vue-simple-spinner'
import swal from 'sweetalert2'
import AppInfo from '@/components/Info'
import AppInfoEmailNotSend from '@/components/InfoEmailNotSend'
import AppFooter from '@/components/root/AppFooter'
import { getFullInfo, trackingReadSMS } from './external.service'
import { isHTML } from '@/helpers/html.js'
export default {
  name: 'AppExternal',

  data () {
    return {
      subject: '',
      remetente: '',
      destinatario: '',
      content: '',
      dataEnviada: '',
      horaEnviada: '',
      dataEntrega: '',
      horaEntrega: '',
      dataLeitura: '',
      horaLeitura: '',
      idImage: '',
      dataLeituraUTC: '',
      emailRawDecoded: '',
      carimboEmail: {},
      detalhesEnvioEntrega: {},
      carimboEmailEntregue: {},
      detalhesLeitura: {},
      provider: 'bry',
      loading: true,
      error: false,
      hasSuccess: true,
      hasSMS: false,
      numeroCelular: '',
      mensagem: '',
      detalhesEnvioEntregaSMS: {},
      detalhesLeituraSMS: {},
      dataEnvioSMS: '',
      dataLeituraSMS: '',
      statusSMS: ''
    }
  },

  components: { AppInfo, AppInfoEmailNotSend, AppFooter, Spinner },

  computed: {
    emailSent () {
      return !this.loading && this.hasSuccess
    },
    emailNotSent () {
      return !this.loading && !this.hasSuccess && !this.hasSMS
    },
    emailNotSentAndHasSMS () {
      return !this.loading && !this.hasSuccess && this.hasSMS
    },
    smsSent () {
      return !this.loading && this.hasSMS && this.detalhesEnvioEntregaSMS.carimbo !== ''
    }
  },

  methods: {
    redirectWhenError () {
      swal({
        title: 'Aviso',
        text: 'Desculpe, mas não foi possível encontrar o e-mail solicitado.',
        type: 'warning'
      })
        .then(() => (window.location.href = 'https://ar-email.com.br'))
    }
  },

  mounted () {
    const uuid = this.$route.params.uuid
    const sms = this.$route.query.sms
    if (sms) {
      trackingReadSMS(sms)
    }
    getFullInfo(uuid)
      .then(response => {
        if (!isHTML(response.content)) {
          return this.redirectWhenError()
        }
        this.subject = response.subject
        this.remetente = response.remetente || ''
        this.content = response.content
        this.hasSuccess = response.hasSuccess
        this.hasSMS = response.hasSMS
        this.destinatario = response.destinatario || ''
        this.dataEnviada = response.dataEnviada || ''
        this.horaEnviada = response.horaEnviada || ''
        this.dataEntrega = response.dataEntrega || ''
        this.horaEntrega = response.horaEntrega || ''
        this.dataLeitura = response.dataLeitura || ''
        this.horaLeitura = response.horaLeitura || ''
        this.idImage = response.idImage || ''
        this.dataLeituraUTC = response.dataLeituraUTC || ''
        this.detalhesEnvioEntrega = response.detalhesEnvioEntrega
        this.detalhesLeitura = response.detalhesLeitura
        this.numeroCelular = response.numeroCelular
        this.mensagem = response.mensagem
        this.detalhesEnvioEntregaSMS = response.detalhesEnvioEntregaSMS
        this.detalhesLeituraSMS = response.detalhesLeituraSMS
        this.dataEnvioSMS = response.dataEnvioSMS
        this.dataLeituraSMS = response.dataLeituraSMS
        this.statusSMS = response.statusSMS
        this.loading = false
      })
      .catch(() => {
        this.loading = false
        this.redirectWhenError()
      })
  }
}
</script>
<style scoped>
  .load-container {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(51, 51, 51, 0.52);
  z-index: 1060;
  display: flex;
  align-content: center;
  align-items: center;
  }
  .load-container>div {
    width: 100%;
  }
@media (max-width:767px){
  .panel-body table * {
    width: 100% !important;
    table-layout: fixed !important;
  }
  .es-wrapper-color{zoom: 50%;}
  .panel-body table a img {
      width: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/external/External.vue